module.exports = __webpack_public_path__ + "img/thankyou_page_box.d6bc48a7.png";